/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getFairTable = params => {
  return axios.post(`${base}/query_fair`, params)
}
export const offlineFair = id => {
  return axios.post(`${base}/offline_fair_${id}`)
}
export const releaseFair = id => {
  return axios.post(`${base}/publish_fair_` + id)
}
export const uploadFair = params => {
  return axios.post(`${base}/upload_fair`, params)
}
export const createFair = params => {
  return axios.post(`${base}/create_fair`, params)
}
export const editFair = params => {
  return axios.post(`${base}/edit_fair_` + params.id, params.data)
}
export const getFairOptions = params => {
  return axios.get(`${base}/fair_options`)
}
export const getFair = id => {
  return axios.get(`${base}/get_fair_` + id)
}
export const deleteFair = id => {
  return axios.post(`${base}/delete_fair_` + id)
}
export const getFairPrizeNumber = params => {
  return axios.get(`${base}/get_prize_number_` + params.fairid)
}
export const getFairUserLimit = params => {
  return axios.post(`${base}/get_fair_reward_user_limit_` + params.fairid, params)
}
export const exportFairCouponHistory = params => {
  return axios.post(`${base}/export_fair_coupon_history_` + params.fairid, params)
}



// WEBPACK FOOTER //
// ./src/views/fair/fair.api.js